import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {UserService} from "src/app/services/user/user.service";
import {AlertService} from "../services/alert/alert.service";
import {HttpErrorResponse} from "@angular/common/http";
import * as uuid from 'uuid';
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  loginForm: UntypedFormGroup;
  loading: false;
  alert = false;
  user: any;
  roles: any;
  menuItems: any;
  remember: boolean;
  showerror: boolean;
  errorText: string = 'Invalid username or password!';
  isEmpty: boolean;
  ar:ActivatedRouteSnapshot;
  state:RouterStateSnapshot;
  visibility: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    public alerts: AlertService
  ) {
    if(JSON.parse(localStorage.getItem('currentRole'))){
      this.router.navigate(['/dashboard'])
    }
  }

  ngOnInit() {
    this.visibility=false;
    this.showerror = false;
    this.isEmpty = false;
    this.remember = false;
    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
      grant_type: ["password", Validators.required]
    });
  }

  onSubmit() {
    Object.keys(this.loginForm.value).length > 0 && (this.isEmpty=false);

    if (this.loginForm.valid) {

      this.alerts.loading();
      this.userService.login(this.loginForm.value).subscribe(
        (data: any) => {

          localStorage.setItem("token", data.access_token);
          localStorage.setItem("refresh_token", data.refresh_token);
          localStorage.setItem("expire_in", data.expires_in);

          this.userService
            .userDetail({
              loginId: this.loginForm.controls.username.value,
              password: this.loginForm.controls.password.value
            })
            .subscribe((d: any) => {
              localStorage.setItem("loginId", d.loginId);
              localStorage.setItem("userId", d.id);
              localStorage.setItem("user", JSON.stringify(d));
              localStorage.setItem("currentRole", JSON.stringify(d.roles));
              localStorage.setItem("customSessionId",`${d.loginId}-${uuid.v4()}`+'-'+Date.now());
              this.user = d;

              this.alerts.closeAlert();

              this.router.navigate(['/dashboard'])

            });
        },
        (error: HttpErrorResponse) => {
          this.alerts.closeAlert();
          if (error.status == 401 || error.status == 400) {
            this.showerror = true;
            this.errorText = 'Invalid username or password!'
            return;
          } else if(error.status == 429) {
            this.showerror = true;
            this.errorText = 'Too many failed attempts, Please try again after few minutes'
            return;
          }
          // this.alerts.toast('error','An error occurred!');
        }
      );
    }
    else{
      this.isEmpty=true;
    }
  }

}
